import type { StoreProductCategory } from "@medusajs/types";

const filterAvailableCategories = (
    categories: StoreProductCategory[],
    availableCategoryIds: string[],
): StoreProductCategory[] =>
    categories
        .filter((category) => availableCategoryIds.includes(category.id))
        .map((category) => ({
            ...category,
            category_children: filterAvailableCategories(
                category.category_children ?? [],
                availableCategoryIds,
            ),
        }));

export const getMenuCategories = (
    categories: StoreProductCategory[] | null = [],
    availableCategoryIds: string[] | null = [],
) => {
    const menuRoot = categories?.find((category) => category.handle === "menu");

    return filterAvailableCategories(
        menuRoot?.category_children ?? [],
        availableCategoryIds ?? [],
    );
};
